exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.card-content[data-v-707972dc] {\n    padding: 0 0 16px 0;\n}\n", ""]);

